import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

const getTitle = (props) => {
  if (props.isSend) {
    return 'Success Resent Verification Email'
  }

  if (props.isSendError) {
    return 'Failed Resend Verification Email'
  }

  return ''
}

const ModalSendVerify = props => (
  <Dialog
    title={getTitle(props)}
    modal={false}
    open={props.isSend || props.isSendError}
    onRequestClose={props.requestClose}
    contentStyle={{ textAlign: 'center', width: '400px' }}
  >
    <FlatButton
      label="OK"
      primary={true}
      onClick={props.requestClose}
    />
  </Dialog>
)

ModalSendVerify.propTypes = {
  isSend: PropTypes.bool.isRequired,
  isSendError: PropTypes.bool.isRequired,
  requestClose: PropTypes.func.isRequired,
}

export default ModalSendVerify
